import React from 'react';

function RadioButton({ label, value, checked, onChange ,sort }) {
    const sortText = sort == 'asc' ? "Low to High" : "High to Low"
  return (
    <>
    <div className="flex flex-row px-2 mx-1 py-1  text-sm text-gray-800 cursor-pointer hover:bg-gray-100">
        <input
         type="radio" 
         value={value}  
         checked = {checked} 
         onChange = {() => onChange(value , sort)}/>
        <label className = "px-4 flex flex-col">
            <span className = "text-md font-bold">{label}</span>
            <span className = "text-sm">{sortText}</span>
            </label>      
    </div>  
    <div className = "border border-b-2 border-gray-100"></div>
   </>
  
  );
}

export default RadioButton;


